// extracted by mini-css-extract-plugin
module.exports = {"DropdownMenu":"styles_DropdownMenu__kfNFO","DropdownMenuActive":"styles_DropdownMenuActive__Jt79j"};